import { marginEdgesRules } from '@fable/components'
import { css, cx, useTheme } from '@fable/theme'
import { CompProps } from 'types'

export const PageContainerV2 = ({
  children,
  className,
  ...nativeProps
}: CompProps<React.HTMLProps<HTMLDivElement>>) => {
  const { mediaQueries } = useTheme()

  return (
    <div
      className={css`
        ${mediaQueries.tabletL} {
          padding: 0 ${marginEdgesRules.tablet};
        }
        ${mediaQueries.desktop} {
          padding: 0 ${marginEdgesRules.desktop} 0;
        }
      `}
    >
      <div
        className={cx(
          css`
            overflow: hidden;
            padding-left: 28px;
            padding-right: 28px;
            ${mediaQueries.mobileL} {
              padding-left: 40px;
              padding-right: 40px;
            }
            ${mediaQueries.tablet} {
              padding-left: 60px;
              padding-right: 60px;
            }
            ${mediaQueries.desktop} {
              padding-left: 80px;
              padding-right: 80px;
            }
          `,
          className
        )}
        {...nativeProps}
      >
        <div
          className={css`
            margin: 0 auto;
            max-width: 1246px;
            width: 100%;
          `}
        >
          {children}
        </div>
      </div>
    </div>
  )
}
